import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params)


    return axios.request({
        url: '/live-type/list',
        data,
        method: 'post'
    })
};
// 获取详情
export const fetchInfo = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/live-type/info',
        data,
        method: 'post'
    })
};
// 添加
export const setAdd = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/live-type/append',
        data,
        method: 'post'
    })
};
// 修改
export const setUpdate = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/live-type/update',
        data,
        method: 'post'
    })
};
// 删除
export const setDel = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/live-type/delete',
        data,
        method: 'post'
    })
};
// 改变状态
export const setStatus = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/live-type/change-status',
        data,
        method: 'post'
    })
};